import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const usePostOrderStatusStore = defineStore({
  id: "postorderstatus",
  state: () => ({
    postOrderStatus: {},
  }),
  getters: {
    getData(state) {
      return state.postOrderStatus.data;
    },
  },
  actions: {
    async getPostOrderStatus(params) {
      const dataparams = {
        limit: params?.limit || 20,
        offset: params?.offset || 0,
      };

      try {
        const result = await debouncedFetch("post_order_status", dataparams);
        const newData = result.data;

        // Override total rows setiap request
        this.postOrderStatus = {
          rows: [...newData.rows],
          count: newData.count,
        };

        return newData;
      } catch (error) {
        console.log(error);
        this.postOrderStatus = error;
      }
    },
  },
});
